(() => {
  if (window.toptanProductGalleryReady) return;
  window.toptanProductGalleryReady = true;

  function selectMedia(gallery, index) {
    const slides = [...gallery.querySelectorAll('[data-toptan-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-toptan-thumb]')];
    if (!slides.length) return;
    const next = (index + slides.length) % slides.length;

    slides.forEach((slide, position) => {
      if (position !== next) {
        slide.querySelectorAll('video').forEach((video) => video.pause());
      }
      slide.hidden = position !== next;
    });
    thumbs.forEach((thumb, position) => thumb.setAttribute('aria-pressed', String(position === next)));
    const counter = gallery.querySelector('[data-toptan-counter]');
    if (counter) counter.textContent = `${next + 1} / ${slides.length}`;
    thumbs[next]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-toptan-thumb], [data-toptan-prev], [data-toptan-next]');
    if (!control) return;
    const gallery = control.closest('[data-toptan-gallery]');
    if (!gallery) return;
    const thumbs = [...gallery.querySelectorAll('[data-toptan-thumb]')];
    const current = [...gallery.querySelectorAll('[data-toptan-slide]')].findIndex((slide) => !slide.hidden);
    const index = control.matches('[data-toptan-prev]') ? current - 1 :
      control.matches('[data-toptan-next]') ? current + 1 : thumbs.indexOf(control);
    selectMedia(gallery, index);
  });
})();
